// extracted by mini-css-extract-plugin
export default {"descriptionLabels":"style_descriptionLabels__Wmggs"};